import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function WeeklyHot() {
  const weeklyHot = [...comics].sort((a, b) => b.views - a.views).slice(0, 5);

  return (
    <section className="py-8 md:py-10 bg-background-100" aria-labelledby="weekly-title">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 id="weekly-title" className="text-lg md:text-xl font-heading text-foreground-900 mb-5">
          本周热搜
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
          {weeklyHot.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.slug}`}
              className="flex items-center gap-3 p-3 rounded-lg bg-background-50 hover:bg-primary-50/50 transition-colors cursor-pointer"
            >
              <span className="text-2xl md:text-3xl font-heading text-primary-300 w-8 text-center flex-shrink-0">
                {String(index + 1).padStart(2, '0')}
              </span>
              <div className="w-14 h-20 rounded overflow-hidden flex-shrink-0">
                <img src={comic.cover} alt={comic.title} className="w-full h-full object-cover object-top" />
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-sm font-semibold text-foreground-900 truncate">{comic.title}</p>
                <p className="text-xs text-foreground-500 mt-0.5">{comic.author}</p>
                <p className="text-xs text-accent-500 mt-0.5">{comic.chapters.length}话 · {comic.status}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}